module.exports = __webpack_public_path__ + "static/img/carousel2.da40964d.png";